import React, {useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {Loader} from '../../../services/Loader'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {
  AuthFooter,
  isCompanyDisabled,
  isUserInactive,
  isUserRoleDisabled,
  paymentLink,
  checkUpgradePaymentRequired,
  isCompanyGracePeriodExpired,
} from '../../../services/Functional'
import {Link, useNavigate} from 'react-router-dom'
import {AuthSidePanel} from './AuthSidePanel'
import {checkSubscriptionExpiry, getInspectionCompanies, handleExpiredCompany, handleIsExpiredCompanyAPIcalling} from '../../../../setup/redux/auth/actions'
import './company-selection.scss'
import {setActiveCompany} from '../../../../setup/redux/auth/slices'
import {endCall} from '../../../../setup/redux/common/slices'
// import '../../../../_metronic/partials/layout/header-menus/company-switch.scss';

// interface Payload {
//   mobile_no?: string
//   email?: string
//   mode: 'mobile' | 'email'
// }

export function CompanySelect() {
  const {config, inspectionCompanies, user}: any = useSelector<RootState>(
    (state) => ({
      user: state.auth.user,
      config: state.configuration.configurations,
      inspectionCompanies: state.auth.inspection_companies,
    }),
    shallowEqual
  )

  const dispatch: Dispatch<any> = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedCompany, setSelectedCompany] = useState<any>(null)

  useEffect(() => {
    dispatch(handleIsExpiredCompanyAPIcalling(false))
    dispatch(handleExpiredCompany(null))
  }, [])

  useEffect(() => {
    setLoading(true)
    dispatch(getInspectionCompanies())
    setLoading(false)
  }, [dispatch])

  const handleCompanyChange = (company: any) => {
    setSelectedCompany(company)
  }

  const handleRedirectionPage = async () => {
    if (user.is_root) {
      dispatch(setActiveCompany(selectedCompany))
      return setTimeout(() => navigate('/dashboard'), 100)
    }

    const groupIds = selectedCompany.groups.map((group: any) => group.slug)

    if (!groupIds.includes('company-admins')) {
      return navigate('/error/auth')
    }

    const {plans, is_expired} = selectedCompany
    const {subscription, payment_status, subscription_type, reference_id} = plans[0]
    const isExpiredGracePeriodCompany = isCompanyGracePeriodExpired(selectedCompany)

    if (subscription.type === 'paid' && payment_status === 'pending') {
      const redirectPaymentUrl = subscription.payment_link[subscription_type] || ''
      return (window.location.href = paymentLink(
        redirectPaymentUrl,
        user.email,
        reference_id
      ))
    }

    if (isExpiredGracePeriodCompany && ((subscription.type === 'paid' && is_expired) || (subscription.type === 'free' && is_expired))) {
      const expiryData: any = await dispatch(checkSubscriptionExpiry(selectedCompany.id))
      if (expiryData?.data?.inspection_company && expiryData.data.inspection_company <= 0) {
        const upgradePaymentData = checkUpgradePaymentRequired(selectedCompany)
        if (upgradePaymentData.required) {
          dispatch(endCall({}))
          return (window.location.href = upgradePaymentData.link!)
        }
        else {
          dispatch(endCall({}))
          dispatch(handleIsExpiredCompanyAPIcalling(true))
          dispatch(handleExpiredCompany(selectedCompany))
          return navigate('/error/access-denied')
        }
      }
    }

    dispatch(setActiveCompany(selectedCompany))
    setTimeout(() => navigate('/dashboard'), 100)
  }

  return (
    <>
      {loading && <Loader />}
      <div className='row w-100 h-100 p-0 m-0'>
        <div className='col-md-7 p-0 bg-white position-relative'>
          <div className='py-5 d-flex justify-content-between container align-items-center mb-8'>
            <img src={config?.actual_logo} alt='logo' width={90} />
            <Link
              to='https://decenthands.com/?page_id=4890'
              className='link-primary fs-6 float-end'
              target='_blank'
            >
              Contact Us
            </Link>
          </div>
          {/* <CompanySwitchMenu /> */}
          <div className='company_select_form_container company_select_container mx-auto d-flex justify-content-center align-items-center h-100'>
            <div className='h-100 d-flex flex-column justify-content-center flex-gap-24 w-100'>
              <div className='d-flex flex-column gap-1'>
                <div className='font-size-20 font-weight-SemiBold letter-spacing-0-2 line-height-30 text-grayish-blue'>
                  Choose a Company
                </div>
                <div className='font-size-14 font-weight-regular line-height-22 text-charcoal com-select-subtitle d-flex flex-column'>
                  <span>Looks like you're logging in</span>
                  <span>Choose a company to start with</span>
                </div>
              </div>
              <div className='company-selection'>
                {inspectionCompanies?.length > 0 &&
                  inspectionCompanies.map((company: any) => (
                    <div className='' key={company.id}>
                      <label
                        className={`btn com-name-container d-flex align-items-center
                          ${isCompanyDisabled(company) || !isUserRoleDisabled(company) || isUserInactive(company) ? 'disable-company-name-container' : ''} 
                          ${selectedCompany?.id === company.id ? 'active-com-name-container' : ''}
                          `}
                        htmlFor={company.name}
                        onClick={() => handleCompanyChange(company)}
                        tabIndex={0}
                      >
                        {company.name}
                      </label>
                    </div>
                  ))}
              </div>
              <button
                type='submit'
                disabled={!selectedCompany}
                onClick={handleRedirectionPage}
                className={`btn btn-primary btn-pill w-100 ${!selectedCompany ? 'disabled-btn' : ''}`}
              >
                Let’s go
                <img
                  className='ms-3'
                  src={'/media/icons/duotune/general/Arrow - Right.svg'}
                  alt='->'
                />
              </button>
            </div>
            <AuthFooter />
          </div>
        </div>
        <div className='col-md-5 p-0 background_card overflow-hidden position-relative'>
          <AuthSidePanel />
        </div>
      </div>
    </>
  )
}
